import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      gap: "24px",
      flexDirection: "row",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        alignItems: "center",
      },
      [theme.breakpoints.up("md")]: {
        [theme.breakpoints.down("lg")]: {
          display: "flex",
          flexWrap: "wrap",
        },
      },
    },
    cardStyle: {
      padding: theme.spacing(3),
      width: "426px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    title: {
      marginBottom: theme.spacing(1),
      color: theme.palette.text.tertiary,
      fontSize: 16,
      fontWeight: 500,
      lineHeight: "24px",
    },
    subTitle: {
      fontSize: 36,
      fontWeight: 600,
      color: theme.palette.text.primary,
      lineHeight: "44px",
    },
    iconContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: theme.palette.background.primary,
      border: `1px solid ${theme.palette.border.secondary}`,
      borderRadius: "10px",
      width: 48,
      height: 48,
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    },
  };
});
